import { AtlassianSite } from '../clients/gateway-client/types';
import { Site } from '../hooks/useSite';
import { ProactiveContextMenuVariants } from '../hooks/useProactiveContextMenuVariants';
import { postMessageToParent } from '../message-bus/postMessageToParent';

export function broadcastConfigToExtension(site: Site | undefined): void {
	postMessageToParent({
		type: 'SITE_DATA_UPDATE',
		value: site && {
			baseUrl: site.defaultSiteBaseUrl,
			cloudId: site.workspace.cloudId,
			orgId: site.workspace.organisationId,
		},
	});
}

export function broadcastEntitlementToExtension(isRovoLLMEnabled?: boolean): void {
	postMessageToParent({
		type: 'ENTITLEMENT_DATA_UPDATE',
		value: {
			isRovoLLMEnabled,
		},
	});
}

// Broadcast the resolved Rovo Context Menu variants to the extension host.
export function broadcastRovoContextMenuVariantsToExtension(
	variants: ProactiveContextMenuVariants,
): void {
	postMessageToParent({
		type: 'SET_ROVO_CONTEXT_MENU_VARIANTS',
		value: variants,
	});
}

export function isSameSite(a?: Site, b?: Site): boolean {
	if (!a && !b) {
		return true;
	}
	if (!a || !b) {
		return false;
	}
	return (
		a.workspace.cloudId === b.workspace.cloudId &&
		a.workspace.organisationId === b.workspace.organisationId &&
		a.defaultSiteBaseUrl === b.defaultSiteBaseUrl
	);
}

/**
 * Compares a Rovo-enabled site (a) with a site in state (b) to check if they are the same.
 *
 * @param a - site object from Rovo-enabled site entitlements response
 * @param b - site object from a React hook
 * @returns
 */
export function isSameEnabledSite(a?: Omit<AtlassianSite, 'siteName'>, b?: Site): boolean {
	return (
		a === b ||
		(a?.cloudId === b?.workspace.cloudId &&
			a?.orgId === b?.workspace.organisationId &&
			a?.baseUrl === b?.defaultSiteBaseUrl)
	);
}
